import { BurgerMenuButton } from '@kit/buttons/burger-menu-button';
import { Box } from '@mui/material';
import { Breadcrumbs } from '@widgets/breadcrumbs';
import { MainLayoutHeaderProfile } from '@widgets/layout/main-layout/main-layout-header/main-layout-header-profile';
import { ProjectSelectorDropdown } from '@widgets/project-selector/project-selector-dropown';

import {
  MainLayoutHeaderDividerBox,
  MainLayoutHeaderLeftBox,
  mainLayoutHeaderProfileSelectorBoxSX,
} from './styled';
import { MainLayoutHeaderType } from './types';

export const MainLayoutHeader: MainLayoutHeaderType = (props) => {
  const { handleLeftDrawerToggle } = props;

  return (
    <>
      <MainLayoutHeaderLeftBox>
        <Box
          component="span" //
          sx={mainLayoutHeaderProfileSelectorBoxSX}
        >
          <ProjectSelectorDropdown />
        </Box>

        <BurgerMenuButton onClick={handleLeftDrawerToggle} />
      </MainLayoutHeaderLeftBox>

      <Breadcrumbs />

      <MainLayoutHeaderDividerBox />

      <MainLayoutHeaderProfile />
    </>
  );
};
